//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import vComponent from '@/core/vComponent'
import { mapGetters } from 'vuex'
import { getLocal } from '@/utils/globalState'
import moment from 'moment'
export default {
  name: 'UserInfo',
  extends: vComponent,
  data () {
    return {
      currentVip: null,
      subPages: [
        { id: 'transaction', label: '交易', icon: 'dashboard' },
        { id: 'ticket', label: '兌換卷', icon: 'payment' }
        /* { id: 'report', label: '分析', icon: 'trending_up' },
        { id: 'tag', label: '註記', icon: 'edit' },
        { id: 'recommend', label: '推薦', icon: 'thumb_up' } */
      ]
    }
  },
  computed: {
    ...mapGetters([
      'dateFormat'
    ])
  },
  created () {
    this.currentVip = getLocal('currentVip')
    /* 先關閉檢查
    if (this.currentVip === null || this.currentVip.ID_NO !== this.params.id_no) {
      // this.to('/viplist')
    }
    */
  },
  mounted () {
  },
  methods: {
    clickBtn (row, type) {
      const url = type === 'transaction' ? `/vip/${row.ID_NO}/${type}/${row.VIP_CODE}` : `/vip/${row.ID_NO}/${type}`
      this.to(url)
    },
    formatBirth (str) {
      return moment(str, 'YYYYMMDD').format(this.dateFormat)
    },
    clickInfo (row) {
      this.to(`/vip/${row.ID_NO}/info/${row.VIP_CODE}`)
    }
  }
}
